import { FieldBag, fieldsToArray } from '@shopify/react-form';
import { useMemo } from 'react';

export const useFormValidation = (formFields: FieldBag) => {
  const isValid = useMemo(() => !fieldsToArray(formFields).find((i) => i.error), [formFields]);

  return { isValid };
};
